export enum TestAttemptStatus {
  NotStarted = 'not-started',
  InProgress = 'in-progress',
  Complete = 'complete',
}
